import React from 'react';
import { FormTreeData } from '@/features/submission_forms/types';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { X, Trash2 } from 'lucide-react';

interface SectionEditorProps {
  section: FormTreeData;
  onUpdate: (updated: Partial<FormTreeData>) => void;
  onDelete: () => void;
  onClose: () => void;
  // Shows the settings without letting them change — the Form Builder is
  // read-only while templates are managed in code.
  readOnly?: boolean;
}

export const SectionEditor: React.FC<SectionEditorProps> = ({
  section,
  onUpdate,
  onDelete,
  onClose,
  readOnly = false,
}) => {
  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold">
          {readOnly ? 'Section' : 'Edit Section'}
        </h3>
        <Button variant="ghost" size="sm" onClick={onClose}>
          <X className="w-4 h-4" />
        </Button>
      </div>

      {/* Form */}
      <fieldset disabled={readOnly} className="space-y-4 min-w-0">
        {/* Section Label */}
        <div>
          <Label htmlFor="section-label">Section Label</Label>
          <Input
            id="section-label"
            value={section.label}
            onChange={e => onUpdate({ label: e.target.value })}
            placeholder="Enter section label"
            className="mt-1"
          />
        </div>

        {/* Danger Zone */}
        {!readOnly && (
          <div className="border-t pt-4 mt-4">
            <Button
              variant="destructive"
              size="sm"
              className="w-full"
              onClick={() => {
                if (
                  confirm(
                    'Are you sure you want to delete this section? This will also delete all questions and subsections.'
                  )
                ) {
                  onDelete();
                  onClose();
                }
              }}
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Section
            </Button>
          </div>
        )}
      </fieldset>
    </div>
  );
};
